<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="row">
    <h2 class="col-12">
      {{ $t("transfert.transfert_marchand_management") }}
      <hr />
    </h2>
    <h6 class="col-12" style="padding-top: 0; margin-top: 0">
      Transférer de l'argent de votre compte marchand à votre portefeuille
      principale.
    </h6>
    <div class="col-12 mb-4">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Recherche"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="transfers"
          :search="search"
          :loading="!transfers"
          loading-text="Chargement en cours..."
          sort-by="label"
          class="elevation-1"
        >
          <template v-slot:item._file="{ item }">
            <a :href="item._file">{{ getFileOriginalName(item._file) }}</a>
          </template>
          <template v-slot:item._created_at="{ item }">
            {{ getDate(item._created_at) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <div style="text-align: right">
              <v-menu key="text" rounded="b-xl">
                <template v-slot:activator="{ attrs, on }">
                  <v-icon class="black--text" v-bind="attrs" v-on="on"
                    >mdi-dots-vertical</v-icon
                  >
                </template>
                <v-list>
                  <v-list-item @click="showdescription(item)">
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-eye</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Détails </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>

          <template v-slot:item.receiver_user._email="{ item }">
            <span>{{
              item.receiver_user ? item.receiver_user._email : "-"
            }}</span>
          </template>
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="800px">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="$store.getters.auth.role._code !== 'admin'"
                    color="default"
                    dark
                    class="mb-2"
                    v-on="on"
                    >{{ $t("add_virement") }}</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title>
                    <v-col md="11" lg="11" sm="11">
                      <span class="headline"> {{ formTitle }} </span>
                    </v-col>
                    <v-col md="1" lg="1" sm="1">
                      <v-icon
                        style="cursor: pointer"
                        @click="setdefaultClose()"
                      >
                        mdi-close
                      </v-icon>
                    </v-col>
                  </v-card-title>

                  <v-card-text>
                    <v-form
                      ref="form"
                      v-model="valid"
                      :lazy-validation="lazy"
                      enctype="multipart/form-data"
                    >
                      <v-stepper v-model="e1">
                        <v-stepper-header>
                          <v-stepper-step :complete="e1 > 1" step="1">
                            Informations du transfert
                          </v-stepper-step>

                          <v-divider></v-divider>

                          <v-stepper-step :complete="e1 > 2" step="2">
                            Motif
                          </v-stepper-step>
                          <v-divider></v-divider>
                          <v-stepper-step :complete="e1 > 3" step="3">
                            Détails
                          </v-stepper-step>
                        </v-stepper-header>
                        <v-text-field
                          v-if="submitting"
                          color="primary"
                          loading
                          disabled
                        ></v-text-field>

                        <v-alert
                          v-if="errors.operation"
                          dense
                          outlined
                          type="error"
                        >
                          {{ errors.operation }}
                        </v-alert>
                        <v-stepper-items>
                          <v-stepper-content step="1">
                            <v-container>
                              <v-row>
                                <v-col
                                  v-if="editedItem._recepteur"
                                  cols="12"
                                  sm="6"
                                  md="12"
                                >
                                  <v-alert
                                    cols="12"
                                    sm="6"
                                    md="12"
                                    color="primary"
                                    text
                                    border="top"
                                    transition="scale-transition"
                                  >
                                    <v-row>
                                      <v-col cols="8">
                                        <v-subheader style="font-weight: bold"
                                          >Le solde de ce compte marchand est de
                                          :</v-subheader
                                        >
                                      </v-col>
                                      <v-col cols="4">
                                        <p
                                          style="
                                            font-weight: bold;
                                            margin-top: 5%;
                                          "
                                          v-if="
                                            editedItem._wallet._amount &&
                                            editedItem._wallet.devise
                                          "
                                        >
                                          {{ editedItem._wallet._amount }}
                                          {{
                                            editedItem._wallet.devise
                                              ._code_alpha
                                          }}
                                        </p>
                                        <p
                                          style="
                                            font-weight: bold;
                                            margin-top: 5%;
                                          "
                                          v-else
                                        >
                                          0
                                        </p>
                                      </v-col>
                                    </v-row>
                                  </v-alert>
                                  <v-alert
                                    v-if="insuf"
                                    dense
                                    outlined
                                    type="error"
                                  >
                                    {{ notif }}
                                  </v-alert>
                                </v-col>
                                <v-col cols="12" sm="12">
                                  <v-form
                                    ref="form"
                                    v-model="valid"
                                    :lazy-validation="lazy"
                                    enctype="multipart/form-data"
                                  >
                                    <v-container style="margin-top: 2%">
                                      <v-col cols="12" sm="12">
                                        <v-text-field
                                          :rules="[
                                            montantRules.loanMin,
                                            montantRules.required,
                                            montantRules.loanMax,
                                          ]"
                                          type="number"
                                          v-model="editedItem._montant"
                                          :label="$t('transfert.montant')"
                                          clearable
                                        ></v-text-field>
                                        <span
                                          >NB: La devise par défaut de votre
                                          compte marchand définis celui du
                                          montant inséré.</span
                                        >
                                      </v-col>
                                      <v-col cols="12" sm="12">
                                        <v-autocomplete
                                          :rules="recepteurRules"
                                          v-model="editedItem._recepteur"
                                          item-value="_id"
                                          :items="marchandu"
                                          :label="
                                            $t('transfert.recepteur_marchand')
                                          "
                                          item-text="_company"
                                          dense
                                          @change="ChangedMarchand()"
                                          persistent-hint
                                        >
                                        </v-autocomplete>
                                      </v-col>
                                    </v-container>
                                  </v-form>
                                </v-col>
                              </v-row>
                            </v-container>

                            <div class="float-right">
                              <v-btn
                                :disabled="
                                  !valid || !editedItem._wallet._amount
                                "
                                color="primary"
                                @click.prevent="suivant"
                              >
                                {{ $t("marchand.continue") }}
                              </v-btn>
                            </div>
                          </v-stepper-content>

                          <v-stepper-content step="2">
                            <v-card-text>
                              <v-form
                                ref="form"
                                v-model="valid"
                                :lazy-validation="lazy"
                                enctype="multipart/form-data"
                              >
                                <v-container style="margin-top: 2%">
                                  <v-col cols="12" sm="12">
                                    <v-textarea
                                      :rules="reasonRules"
                                      v-model="editedItem._reason"
                                      single-line
                                      counter
                                      maxlength="120"
                                      :label="$t('transfert.reason_text')"
                                    ></v-textarea>
                                  </v-col>
                                </v-container>
                              </v-form>
                            </v-card-text>

                            <div class="float-right">
                              <v-btn class="dark" @click="e1 = 1">
                                {{ $t("marchand.retour") }}
                              </v-btn>
                              <v-btn
                                :disabled="!editedItem._reason"
                                color="primary"
                                style="margin-left: 15px"
                                @click.prevent="suivant1"
                              >
                                {{ $t("marchand.continue") }}
                              </v-btn>
                            </div>
                          </v-stepper-content>
                          <v-stepper-content step="3">
                            <v-card-text>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                class="text-lg-center"
                                style="font-weight: bold; font-size: 18px"
                              >
                                DETAILS DU TRANSFERT
                              </v-col>
                              <v-row>
                                <v-col cols="6" sm="6" md="6">
                                  <span style="font-weight: bold">
                                    Compte principal :</span
                                  >{{ $store.getters.auth._email }}
                                </v-col>
                                <v-col
                                  cols="6"
                                  sm="6"
                                  md="6"
                                  v-if="editedItem._wallet.devise"
                                >
                                  <span style="font-weight: bold">
                                    Montant du transfert: </span
                                  >{{ editedItem._montant }}
                                  {{ editedItem._wallet.devise._code_alpha }}
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  <span style="font-weight: bold">
                                    Compte marchand : </span
                                  >{{ march }}
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="12"
                                  style="text-align: center"
                                >
                                  <span style="font-weight: bold">
                                    Motif :
                                  </span>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  {{ editedItem._reason }}
                                </v-col>
                              </v-row>
                            </v-card-text>

                            <div class="float-right">
                              <v-btn class="dark" @click="e1 = 2">
                                {{ $t("marchand.retour") }}
                              </v-btn>
                              <v-btn
                                style="margin-left: 15px"
                                :disabled="mis || insuf"
                                class="primary"
                                @click.prevent="save"
                                >Envoyer</v-btn
                              >
                            </div>
                          </v-stepper-content>
                        </v-stepper-items>
                      </v-stepper>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-toolbar>

            <v-dialog v-model="dialog1" max-width="500px">
              <v-card>
                <v-card-title>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    class="text-lg-center"
                    style="font-weight: bold; font-size: 18px"
                  >
                    DETAILS DU TRANSFERT
                  </v-col>
                </v-card-title>

                <v-card-text>
                  <v-row>
                    <v-col v-if="desc.receiver_user" cols="12" sm="6" md="6">
                      <span style="font-weight: bold"> Nom :</span>
                      <span v-if="desc.receiver_user._first_name">
                        {{ desc.receiver_user._first_name }}
                      </span>
                      <span v-else> --- </span>
                    </v-col>

                    <v-col v-if="desc.receiver_user" cols="12" sm="6" md="6">
                      <span style="font-weight: bold"> Prénom : </span>
                      <span v-if="desc.receiver_user._last_name">
                        {{ desc.receiver_user._last_name }}
                      </span>
                      <span v-else> --- </span>
                    </v-col>

                    <v-col v-if="desc.receiver_user" cols="12" sm="6" md="6">
                      <span style="font-weight: bold"> Email : </span>
                      {{ desc.receiver_user._email }}
                    </v-col>
                    <v-col
                      v-else
                      cols="12"
                      sm="6"
                      md="6"
                      style="font-weight: bold"
                    >
                      Email : ---
                    </v-col>

                    <v-col v-if="desc.x_currency" cols="12" sm="6" md="6">
                      <span style="font-weight: bold"> Montant Envoyer : </span>
                      {{ desc._amount }} {{ desc.x_currency._code_alpha }}
                    </v-col>
                    <v-col
                      v-if="desc._received_amount && desc.wallet_currency"
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <span style="font-weight: bold"> Montant Reçu : </span>
                      {{ desc._received_amount }}
                      {{ desc.wallet_currency._code_alpha }}
                    </v-col>

                    <v-col v-if="desc.sender_marchand" cols="12" sm="6" md="6">
                      <span style="font-weight: bold">
                        Compte marchand du transfert :
                      </span>
                      {{ desc.sender_marchand._company }}
                    </v-col>
                    <v-col cols="12" sm="12" md="12" style="text-align: center">
                      <span style="font-weight: bold"> Motif : </span>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      {{ desc._reason }}
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click.prevent="close1">{{
                    $t("close")
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <template v-slot:item._amount="{ item }">
            <span v-if="item.x_currency">
              {{ item._amount }} {{ item.x_currency._code_alpha }}
            </span>
          </template>
          <template v-slot:no-data>
            <span>{{ $t("no_data") }}</span>
          </template>
        </v-data-table>
      </v-card>
      <customsnackbar
        :snackbar="customSnack.snackbar"
        :text="customSnack.text"
        :snackcolor="customSnack.snackcolor"
        :snackbBtnColor="customSnack.snackbBtnColor"
        :snacktimeout="customSnack.snacktimeout"
      >
      </customsnackbar>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import helpers from "../../../../mixins/helpers";

export default {
  name: "TransferMarchand",
  mixins: [helpers(this)],
  data() {
    return {
      submitting: false,
      valid: true,
      lazy: false,
      mis: false,
      insuf: false,
      items: ["Foo", "Bar", "Fizz", "Buzz"],
      errors: {},
      e1: 1,
      customSnack: {
        snackbar: false,
        text: "",
        snackcolor: "black",
        snackbBtnColor: "white",
        snacktimeout: 2000,
      },
      search: "",
      march: "",
      notif: "",
      desc: "",
      step1: false,
      step2: false,
      step3: true,
      dialog: "",
      generaldatas: {},
      dialog1: "",
      id: undefined,
      categorieHasChanged: false,
      headers: [
        { text: "Référence", value: "_reference" },
        {
          text: "Compte marchand du transfert",
          value: "sender_marchand._email",
        },
        { text: this.$t("transfert.montant"), value: "_amount" },
        { text: this.$t("date"), value: "_created_at" },
        { text: "", value: "actions", sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        _montant: "",
        _recepteur: "",
        _reason: "",
        _wallet: "",
        _created_at: 0,
        _id: "",
      },
      defaultItem: {
        _montant: "",
        _recepteur: "",
        _reason: "",
        _wallet: "",
        _created_at: 0,
        _id: "",
      },
      recepteurRules: [
        (v) => !!v || this.$t("transfert.requis_recepteur"),
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      montantRules: {
        required: (v) => !!v || this.$t("transfert.requis_montant"),
        loanMin: (v) =>
          v >= parseFloat(this.generaldatas.mmintr) ||
          "Veuillez entrer le montant minimum de transfert. Montant >=" +
            this.generaldatas.mmintr,
        loanMax: (v) =>
          v <= parseFloat(this.generaldatas.mmaxtr) ||
          "Le montant que vous aviez entré depassé le montant maximum de transfert. Montant <=" +
            this.generaldatas.mmaxtr,
        loanMaxMax: (v) =>
          (parseFloat(v) * parseFloat(this.generaldatas.tt)) / 100 +
            parseFloat(v) <=
            this.editedItem._wallet._amount ||
          `Votre solde est inférieur au  montant net du transfert.`,
      },
      reasonRules: [(v) => !!v || this.$t("transfert.requis_reason")],

      rules: {
        required: (value) => !!value || "Entrer l'émail du receptuer",
        min: (v) =>
          (v !== undefined && v.length >= 8) || this.$t("min_8_caracters"),
        match: (v) => v == this.password || this.$t("password_mismatch"),
        email: (v) =>
          v.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) || this.$t("invalid_email"),
        tel: (v) =>
          v.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s/0-9]*$/g) ||
          this.$t("invalid_phone"),
        //email: v => (v.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) ||  this.$t('invalid_email'),
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("transfert.new_virement")
        : this.$t("transfert.update_transfert");
    },
    ...mapState("users/", ["users"]),
    ...mapState("users/", ["user"]),
    ...mapState("transfers/", ["transfers"]),
    ...mapState("marchands/", ["marchand"]),
    ...mapState("wallets/", ["wallet"]),
    ...mapState("marchands/", ["marchandu"]),
  },
  mounted() {
    this.$store.dispatch("users/getUsers").then((response) => {
      window.console.log("users", response);
    });
    this.$store.dispatch("marchands/getMarchandUser").then((response) => {
      console.log("liste marchands", response);
      //{ company: 'Click Me', id:"" }
      this.allmarchands =
        response && response.data && response.data.marchandu
          ? response.data.marchandu
          : {};
    });
    let data2 = new FormData();
    data2.append("devise", this.$store.getters.auth.wallet.devise._id);

    this.$store
      .dispatch("generalsettings/getGeneralSettingForMarchandDevise", data2)
      .then((response) => {
        console.log("getGeneralSettingAdmin", response);
        this.generaldatas = response.generalsettings;
      });
    let datarec = { type: "marchand", id: this.$store.getters.marchand._id };
    this.$store.dispatch("transfers/getTransfer", datarec).then((response) => {
      console.log("transfers marchand", response);
    });
    this.$store.dispatch("marchands/getMarchandOne").then((response) => {
      console.log("marchand", response);
    });
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialog1(val) {
      val || this.close1();
    },
  },
  methods: {
    initialize() {
      this.langues = [
        {
          name: "Bénin",
          code_iso_alpha_2: "BJ",
          code_iso_alpha_3: "BEN",
          code_iso_numerique: 204,
        },
      ];
    },
    suivant() {
      this.e1 = 2;
    },
    suivant1() {
      this.e1 = 3;
    },
    setdefaultClose() {
      this.e1 = 1;
      this.step1 = false;
      this.step2 = false;
      this.step3 = true;
      this.dialog = false;
    },
    ChangedMarchand() {
      this.$store
        .dispatch("wallets/getwallet", this.editedItem._recepteur)
        .then(() => {
          this.submitting = false;
          if (this.wallet) {
            console.log("wallet", this.wallet);
            this.editedItem._wallet = this.wallet;
          }
          if (
            (parseFloat(this.editedItem._amount) *
              parseFloat(this.generaldatas.tt)) /
              100 +
              parseFloat(this.editedItem._amount) <=
            this.editedItem._wallet._amount
          ) {
            this.notif =
              "Votre solde est inférieur au  montant net du transfert";
            this.insuf = true;
          } else {
            this.insuf = false;
          }
        });
      this.$store
        .dispatch("marchands/getmarchandDetails", this.editedItem._recepteur)
        .then(() => {
          this.submitting = false;
          if (this.marchand) {
            this.march = this.marchand._email;
          }
        });
    },
    editItem(item) {
      this.editedIndex = this.transfers.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.id = item._id;
    },
    showdescription(vdes) {
      if (vdes === undefined) {
        this.desc = "Vide";
        this.dialog1 = true;
      } else {
        this.desc = vdes;
        this.dialog1 = true;
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$refs.form.reset();
    },
    close1() {
      this.dialog1 = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    categorieChanged() {
      this.categorieHasChanged = true;
    },

    save() {
      let VueBox = this;
      let data = new FormData();
      this.mis = true;
      data.append("amount", this.editedItem._montant);
      data.append("type", "M_C");
      data.append("sender_id", this.editedItem._recepteur);
      data.append("email", this.$store.getters.auth._email);
      data.append("reason", this.editedItem._reason);
      if (this.id) data.append("id", this.id);
      this.submitting = true;
      this.$store.dispatch("transfers/setTransfer", data).then((response) => {
        console.log("set transfer response", response);
        this.submitting = false;
        if (response.error) {
          this.errors.operation = response.message;
        } else {
          VueBox.$parent.resetDatas(VueBox);
          this.close();
          this.showSnackDefault(response);
          let datarec = {
            type: "marchand",
            id: this.$store.getters.marchand._id,
          };
          this.$store
            .dispatch("transfers/getTransfer", datarec)
            .then((response) => {
              console.log("transfers", response);
            });
        }
      });
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },
    fileChange() {
      console.log(this.$refs);
      this.editedItem._file = this.$refs.file.files[0];
    },
    getFileOriginalName(file) {
      return file.substr(file.lastIndexOf("/") + 1);
    },
  },
  created() {
    this.checkisDashboard();
    this.initialize();
  },
};
</script>

<style scoped></style>
